import { render, staticRenderFns } from "./CoverSummary.vue?vue&type=template&id=3d58689e&scoped=true"
import script from "./CoverSummary.vue?vue&type=script&lang=js"
export * from "./CoverSummary.vue?vue&type=script&lang=js"
import style0 from "./CoverSummary.vue?vue&type=style&index=0&id=3d58689e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d58689e",
  null
  
)

export default component.exports